// routes/NodeSelection.jsx — 사람 Node 가 여럿일 때.
//
// 서버가 애매할 때 하나를 골라 주지 않는 이유와 같은 이유로 화면도 고르지 않는다.
// 골라 주면 그 선택은 사람이 한 적 없는 선택이고, 그 뒤의 모든 판단이 그 위에 쌓인다.

import { describeError } from '../api/errors.js';
import { Button, List, ListRow, Notice } from '../ui/primitives.jsx';

export function NodeSelection({ candidates = [], error, onSelect }) {
  return (
    <main class="plain">
      <div class="plain__inner plain__inner--reading">
        <header class="plain__head">
          <h1 class="t-view">어느 이름으로 들어가시겠습니까</h1>
          <p class="t-meta prose">
            이 계정에 연결된 자리가 여럿입니다. 고른 자리로 말하게 되고, 그 자리의 미결 약속을
            이어받습니다.
          </p>
        </header>

        {error ? <Notice tone="danger" title={describeError(error).message} /> : null}

        {candidates.length === 0 ? (
          <Notice
            tone="waiting"
            title="고를 수 있는 자리를 받지 못했습니다."
            action={<Button size="sm" onClick={() => window.location.reload()}>다시 시도</Button>}
          />
        ) : (
          <List>
            {candidates.map((c) => (
              <ListRow key={c.nodeId} onActivate={() => onSelect?.(c.nodeId)}>
                <span class="grow">
                  <span class="t-body-strong">{c.displayName ?? '이름 없는 자리'}</span>
                </span>
                <span class="t-meta">{c.kind === 'hybrid' ? '사람+AI' : '사람'}</span>
              </ListRow>
            ))}
          </List>
        )}
      </div>
    </main>
  );
}
